/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { Broker } from "./Broker";
import {
  BrokerFromJSON,
  BrokerFromJSONTyped,
  BrokerToJSON,
  BrokerToJSONTyped,
} from "./Broker";

/**
 *
 * @export
 * @interface SavedBroker
 */
export interface SavedBroker {
  /**
   *
   * @type {string}
   * @memberof SavedBroker
   */
  savedBrokerId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SavedBroker
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof SavedBroker
   */
  companyId?: string;
  /**
   *
   * @type {Broker}
   * @memberof SavedBroker
   */
  broker?: Broker;
}

/**
 * Check if a given object implements the SavedBroker interface.
 */
export function instanceOfSavedBroker(value: object): value is SavedBroker {
  return true;
}

export function SavedBrokerFromJSON(json: any): SavedBroker {
  return SavedBrokerFromJSONTyped(json, false);
}

export function SavedBrokerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedBroker {
  if (json == null) {
    return json;
  }
  return {
    savedBrokerId:
      json["savedBrokerId"] == null ? undefined : json["savedBrokerId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    broker: json["broker"] == null ? undefined : BrokerFromJSON(json["broker"]),
  };
}

export function SavedBrokerToJSON(json: any): SavedBroker {
  return SavedBrokerToJSONTyped(json, false);
}

export function SavedBrokerToJSONTyped(
  value?: SavedBroker | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedBrokerId: value["savedBrokerId"],
    createdAt: value["createdAt"],
    companyId: value["companyId"],
    broker: BrokerToJSON(value["broker"]),
  };
}
